import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import LegalHeader from '../components/LegalHeader';

const LegalNotice = () => {
  const { t } = useLanguage();

  // Format date for display
  const lastUpdatedDate = '2 de junio de 2026';
  const lastUpdatedText = t('legalNotice.lastUpdated').replace('{date}', lastUpdatedDate);

  const prohibitions = t('legalNotice.sections.termsOfUse.prohibitions');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation Header */}
      <LegalHeader />

      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 text-center">
          <div className="flex justify-center items-center space-x-4 mb-4">
            <img
              src="/farm-logo.png"
              alt="FARM Logo"
              className="w-12 h-12 rounded-xl"
            />
            <h1 className="text-3xl font-bold text-gray-900">{t('legalNotice.title')}</h1>
          </div>
        </div>
      </div>

      {/* Contenido */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">

          {/* Identificación de la empresa */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('legalNotice.sections.companyId.title')}</h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">{t('legalNotice.sections.companyId.companyName')}</h3>
                  <p className="text-gray-700">ADVISER GROUP COMMUNITY SLU</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">{t('legalNotice.sections.companyId.appName')}</h3>
                  <p className="text-gray-700">FARM</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">{t('legalNotice.sections.companyId.taxId')}</h3>
                  <p className="text-gray-700">B66883687</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">{t('legalNotice.sections.companyId.contactEmail')}</h3>
                  <p className="text-gray-700">
                    <a href="mailto:support@farmway.dev" className="text-blue-600 hover:text-blue-800">
                      support@farmway.dev
                    </a>
                  </p>
                </div>
              </div>

              <div className="mt-6">
                <h3 className="font-semibold text-gray-900 mb-2">{t('legalNotice.sections.companyId.address')}</h3>
                <p className="text-gray-700">
                  Gran Vía Carles III, 98, 10º<br />
                  08028 Barcelona<br />
                  España
                </p>
              </div>

              <div className="mt-6">
                <h3 className="font-semibold text-gray-900 mb-2">{t('legalNotice.sections.companyId.commercialRegistry')}</h3>
                <p className="text-gray-700">
                  {t('legalNotice.sections.companyId.registeredIn')}<br />
                  {t('legalNotice.sections.companyId.volume')}: 45650<br />
                  {t('legalNotice.sections.companyId.folio')}: 161<br />
                  {t('legalNotice.sections.companyId.sheet')}: 494623<br />
                  {t('legalNotice.sections.companyId.entry')}: 1ª
                </p>
              </div>
            </div>
          </section>

          {/* Objeto social */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('legalNotice.sections.purpose.title')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('legalNotice.sections.purpose.content')}
            </p>
          </section>

          {/* Condiciones de uso */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('legalNotice.sections.termsOfUse.title')}</h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                {t('legalNotice.sections.termsOfUse.intro')}
              </p>
              <p>
                {t('legalNotice.sections.termsOfUse.commitment')}
              </p>
              <ul className="list-disc pl-6 space-y-2">
                {Array.isArray(prohibitions) && prohibitions.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </section>

          {/* Propiedad intelectual */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('legalNotice.sections.intellectualProperty.title')}</h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                {t('legalNotice.sections.intellectualProperty.content1')}
              </p>
              <p>
                {t('legalNotice.sections.intellectualProperty.content2')}
              </p>
              <p>
                {t('legalNotice.sections.intellectualProperty.content3')}
              </p>
            </div>
          </section>

          {/* Exclusión de garantías */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('legalNotice.sections.disclaimer.title')}</h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                {t('legalNotice.sections.disclaimer.content1')}
              </p>
              <p>
                {t('legalNotice.sections.disclaimer.content2')}
              </p>
            </div>
          </section>

          {/* Modificaciones */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('legalNotice.sections.modifications.title')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('legalNotice.sections.modifications.content')}
            </p>
          </section>

          {/* Legislación aplicable */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('legalNotice.sections.jurisdiction.title')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('legalNotice.sections.jurisdiction.content')}
            </p>
          </section>

          {/* Fecha de actualización */}
          <section className="border-t pt-6">
            <p className="text-sm text-gray-500">
              {lastUpdatedText}
            </p>
          </section>

        </div>

        {/* Botón de volver */}
        <div className="mt-8 text-center">
          <button
            onClick={() => window.history.back()}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200"
          >
            {t('legalNotice.backButton')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
